import React from 'react'
import { ArgosPlusLogo as BoltArgosPlusLogo } from '@sainsburys-tech/bolt-icons'

const ArgosPlusLogo = ({ className }) => (
  <BoltArgosPlusLogo width='64' role='img' aria-label='Argos Plus' className={className} />
)

export default ArgosPlusLogo
